import axios, { AxiosError, AxiosResponse } from 'axios'
import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useRecoilState } from 'recoil'
import { currentPlayState } from '../../../../../src/atoms/CurrentPlayAtom'
import { pageState } from '../../../../../src/atoms/PageAtom'
import { pastPageState } from '../../../../../src/atoms/PastPageAtom'
import { playQueueState } from '../../../../../src/atoms/PlayQueueAtom'

import pauseIcon from '../../../../../src/assets/images/icons/pause.svg'
import playIcon from '../../../../../src/assets/images/icons/play.svg'

import GenerativeModal from './modal'

type Artist = {
  public_id: string
  display_name: string
}

type Generative = {
  public_id: string
  contract_address: string
  name: string
  chain_id: number
  uri: string
  artist: Artist
}

type PickupGenerative = {
  abi_uri: string
  mint_func: string | null
  price: string
  outer_link: string | null
  cover_image_uri: string
  music_uri: string
  max_supply: number
  total_supply: number
  generative: Generative
}

type Props = {
  web3: Web3
}

function HomeGeneratives(props: Props) {
  const { t } = useTranslation()
  const [page, setPage] = useRecoilState(pageState)
  const [, setPastPage] = useRecoilState(pastPageState)
  const [, setPlayList] = useRecoilState(playQueueState)
  const [currentPlay, setCurrentPlay] = useRecoilState(currentPlayState)

  const [pickupGeneratives, setPickupGeneratives] =
    useState<PickupGenerative[]>()
  const [openGenerative, setOpenGenerative] = useState<
    PickupGenerative | undefined
  >()

  useEffect(() => {
    fetchHomeGeneratives()
  }, [])

  const fetchHomeGeneratives = () => {
    axios({
      method: 'GET',
      url: `${import.meta.env.VITE_API_BASE_URI}/api/v1/home/generatives`,
    })
      .then(
        (
          response: AxiosResponse<{ pickup_generatives: PickupGenerative[] }>
        ) => {
          setPickupGeneratives(response.data.pickup_generatives)
        }
      )
      .catch((error: AxiosError<{ error: string }>) => {
        console.error('error', error)
      })
  }

  type MusicNft = {
    chain_id: number
    contract_address: string
    token_id: string
    name: string
    image: string
    sound: string
    artist_name: string
    artist_public_id: string
  }
  const playMusic = (target: MusicNft) => {
    setPlayList([target])
  }

  const generativeContents = (
    <div className="generatives">
      {pickupGeneratives && pickupGeneratives.length > 0 ? (
        pickupGeneratives.map((pickupGenerative) => (
          <div
            className="generative"
            key={pickupGenerative.generative.public_id}
            onClick={(event) => {
              event.stopPropagation()
              setPastPage('home')
              setPage(
                `generatives/${pickupGenerative.generative.public_id}/detail`
              )
            }}
          >
            <div
              className="image"
              style={{
                backgroundImage: `url(${pickupGenerative.cover_image_uri})`,
              }}
              onClick={(event) => {
                event.stopPropagation()
              }}
            >
              <div className="navigation">
                <button className="icon"></button>
                {currentPlay.chainId === pickupGenerative.generative.chain_id &&
                currentPlay.contractAddress ===
                  pickupGenerative.generative.contract_address &&
                currentPlay.tokenId === '1' &&
                currentPlay.playStatus ? (
                  <button
                    className="play"
                    aria-label="停止"
                    style={{ backgroundImage: `url(${pauseIcon})` }}
                    onClick={(event) => {
                      event.stopPropagation()
                      const dupCurrentPlay = Object.assign({}, currentPlay)
                      dupCurrentPlay.outerPause = true
                      setCurrentPlay(dupCurrentPlay)
                    }}
                  ></button>
                ) : (
                  <button
                    className="play"
                    aria-label="再生"
                    style={{ backgroundImage: `url(${playIcon})` }}
                    onClick={(event) => {
                      event.stopPropagation()
                      playMusic({
                        chain_id: pickupGenerative.generative.chain_id,
                        contract_address:
                          pickupGenerative.generative.contract_address,
                        token_id: '1',
                        name: pickupGenerative.generative.name,
                        image: pickupGenerative.cover_image_uri,
                        sound: pickupGenerative.music_uri,
                        artist_name:
                          pickupGenerative.generative.artist.display_name,
                        artist_public_id:
                          pickupGenerative.generative.artist.public_id,
                      })
                    }}
                  ></button>
                )}
                <button className="icon"></button>
              </div>
            </div>

            <div className="datum">
              <h3 className="data ttl">{pickupGenerative.generative.name}</h3>
              <button
                className="data button"
                onClick={(event) => {
                  event.stopPropagation()
                  setPastPage('home')
                  setPage(
                    `artists/${pickupGenerative.generative.artist.public_id}`
                  )
                }}
              >
                <span className="user-icon"></span>
                <span className="artist-name">
                  {pickupGenerative.generative.artist.display_name}
                </span>
              </button>
              <p className="data supply">
                発行枚数
                <span className="num">
                  {pickupGenerative.total_supply.toLocaleString('en-US')}/
                  {pickupGenerative.max_supply.toLocaleString('en-US')}
                </span>
              </p>
              <button
                className="data mint"
                onClick={(event) => {
                  event.stopPropagation()
                  setOpenGenerative(pickupGenerative)
                }}
              >
                MINTする
              </button>
              {/* <a
                className="data mint"
                href={pickupGenerative.generative.uri}
                target="_blank"
                rel="nofollow noopener noreferrer"
                onClick={(event) => {
                  event.stopPropagation()
                }}
              >
                MINTする
              </a> */}
            </div>
          </div>
        ))
      ) : (
        <></>
      )}
    </div>
  )

  return pickupGeneratives && pickupGeneratives.length > 0 ? (
    <section className="section generatives-section">
      <div className="ttl-flex">
        <h2 className="section-ttl">イチオシのジェネラティブ</h2>
        <button className="more-button" onClick={() => setPage('generatives')}>
          {t('parts.moreButton.text')}
        </button>
      </div>
      {generativeContents}
      {openGenerative && (
        <GenerativeModal
          web3={props.web3}
          pickupGenerative={openGenerative}
          setOpenGenerative={setOpenGenerative}
        />
      )}
    </section>
  ) : (
    <></>
  )
}

export default HomeGeneratives
